// 法人情報登録確認
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Button } from 'react-bootstrap';
import axios from '../../../axios';
import { handleBrowserBack } from '../../../BrowserBack';
import { isBrowserIe } from '../../../BrowserJudgment';
import { api_response_type } from '../../../Const';
import { ResponseDetailType, GroupLabelType } from '../../../types/Corporate';
import { GroupLabel, LabelData } from '../../../const/Corporate';
import PopupStaff from '../../../molecules/PopupStaff';
import LoadingModal from '../../../molecules/LoadingModal';
import { KWMNTGM05030A01, KWMNTGM05110A02, KWMNTGM05110A03 } from '../../../const/api_modules';
import { CorporationInfoFormatValue } from '../../../Common';

const CorporateInfoEntryConfirm = () => {
  const [data, setData] = useState<ResponseDetailType | undefined>(undefined);
  // 相関チェックのエラーメッセージ
  const [error_message, setErrorMessage] = useState('');
  // ポップアップの表示制御
  const [is_popup, setIsPopup] = useState(false);
  const [is_loading, setIsLoading] = useState(false);

  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const corporate_id = url_params.get('corporate_id');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 初期値のデータを取得
    getData();
  }, []);

  // 初期値のデータを取得
  const getData = async () => {
    setIsLoading(true);
    try {
      const detail = [{ id: 0, name: 'id', value: corporate_id }];

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWMNTGM05030A01,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : detail,
      });

      if (response.data.result) {
        setData(response.data.detail);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 【差戻し】ボタン押下時の処理
   */
  const handleSendBack = async () => {
    setIsLoading(true);
    try {
      const detail = [
        { id: 0, name: 'id', value: corporate_id },
        { id: 0, name: 'updated_at', value: data?.updated_at ?? null },
      ];

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWMNTGM05110A03,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : detail,
      });

      if (response.data.response_type === api_response_type.transition_to_corporate_info_detail) {
        // レスポンスされたidをパラメータにセットし、詳細画面に遷移
        location.replace(
          `${location.origin}${process.env.MIX_MOCK_URL}/staff/corporate_info_detail?corporate_id=${corporate_id}`
        );
      } else {
        if (response.data.response_type === api_response_type.validation) {
          if (response.data.detail.length > 0) {
            alert(response.data.detail[0].message);
          }
        }
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 【確認】ボタン押下時の処理
   */
  const handleConfirm = async () => {
    setIsLoading(true);
    // エラー初期化
    setErrorMessage('');

    try {
      const detail = [
        { id: 0, name: 'id', value: corporate_id },
        { id: 0, name: 'updated_at', value: data?.updated_at ?? null },
      ];

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWMNTGM05110A02,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : detail,
      });

      // APIからの応答種別を判定（相関チェック）
      if (response.data.response_type === api_response_type.error) {
        //モーダルでメッセージを表示
        setErrorMessage(response.data.message);
        setIsPopup(true);
      } else if (response.data.response_type === api_response_type.validation) {
        if (response.data.detail.length > 0) {
          alert(response.data.detail[0].message);
        }
      } else if (response.data.response_type === api_response_type.navigation_finish) {
        // 完了画面に遷移
        location.replace(
          `${location.origin}${process.env.MIX_MOCK_URL}/staff/corporate_info_entry_complete`
        );
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 【戻る】ボタン押下時の処理
   */
  const backTransition = () => {
    if (isBrowserIe()) {
      const node = document.getElementById('corporate-info-entry-confirm');
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <div className="corporate">
      <div className="title">法人情報</div>
      <div className="container">
        <div className="contents">
          <p className="contents_title mb-5">法人情報登録(確認)</p>
          <div className="group_wrapper">
            {GroupLabel.map((item: GroupLabelType) => (
              <div className="text_field_wrapper" key={item.type}>
                <p className="section_label">{item.label}</p>
                {Object.entries(LabelData[item.type]).map(([key, value]) => (
                  <dl className="field_section" key={key}>
                    <dt className="field_label">{typeof value === 'string' && value}</dt>
                    <dd className="field_data">
                      {data &&
                        Object.entries(data.corporate_information).map(
                          ([key2, value2]) => key2 === key && CorporationInfoFormatValue(value2, key)
                        )}
                    </dd>
                  </dl>
                ))}
              </div>
            ))}
            <dl className="field_section mt-5">
              <dt className="field_label">編集コメント</dt>
              <dd className="field_data">{data?.corporate_information.temp_comment}</dd>
            </dl>
            <div className="mx-auto my-5 d-flex justify-content-between">
              <Button
                className="btn-mini btn-text-color"
                variant="outline-success"
                onClick={backTransition}
              >
                戻る
              </Button>
              <Button className="btn-mini btn-danger" onClick={handleSendBack}>
                差戻し
              </Button>
              <Button className="btn-mini btn-success" onClick={handleConfirm}>
                登録
              </Button>
            </div>
          </div>
        </div>
      </div>
      <PopupStaff
        toggleShow={is_popup}
        text={error_message}
        btn1_label={'OK'}
        btn1_css={'btn-danger'}
        btn1_func={() => setIsPopup(false)}
      />
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('corporate-info-entry-confirm')) {
  render(<CorporateInfoEntryConfirm />, document.getElementById('corporate-info-entry-confirm'));
}
